import React from 'react';

export const TARIFFS = {
  cosmetic: {
    name: 'Косметический',
    price: 18000,
    description: (
      <>
        Замена отделочных покрытий стен, пола и&nbsp;потолка. Материалы
        не&nbsp;входят в&nbsp;тариф.
      </>
    ),
    caption: <>Работы ведутся с&nbsp;использованием традиционных технологий.</>,
  },
  capital: {
    name: 'Капитальный',
    price: 33000,
    description: (
      <>
        Полный комплекс строительно-отделочных работ, выполненных
        с&nbsp;соблюдением строительных норм и&nbsp;стандартов.
      </>
    ),
    caption: (
      <>
        Полный комплекс строительно-отделочных работ, выполненных
        с&nbsp;соблюдением строительных норм и&nbsp;стандартов.
      </>
    ),
  },
  design: {
    name: 'Дизайнерский',
    price: 56000,
    description: (
      <>
        Любые виды демонтажных и&nbsp;отделочных работ, включая перепланировку.
        Сложные технологические и&nbsp;технические решения. Работа
        с&nbsp;дорогими материалами и&nbsp;инструментом.
      </>
    ),
    caption: (
      <>
        Полный комплекс строительно-отделочных работ, выполненных
        с&nbsp;соблюдением строительных норм и&nbsp;стандартов.
      </>
    ),
  },
  custom: {
    name: 'Индивидуальный',
    price: 0,
    description: (
      <>Выберите работы и&nbsp;услуги, которые нужны для вашего ремонта.</>
    ),
    caption: <></>,
  },
};
